import { render, staticRenderFns } from "./sectionModel.vue?vue&type=template&id=267325e9&"
import script from "./sectionModel.vue?vue&type=script&lang=js&"
export * from "./sectionModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports